/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remembered in your profile on this device`)
};

const es_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordado en tu perfil en este dispositivo`)
};

const de_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In deinem Profil auf diesem Gerät gemerkt`)
};

const nl_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onthouden in je profiel op dit apparaat`)
};

const fr_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mémorisé dans votre profil sur cet appareil`)
};

const it_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricordato nel tuo profilo su questo dispositivo`)
};

const pt_br2_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrado no seu perfil neste dispositivo`)
};

const pt_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado no teu perfil neste dispositivo`)
};

const ja_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスのプロフィールに記憶済み`)
};

const zh_health_profile_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已记住在此设备的个人资料中`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const health_profile_saved = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.health_profile_saved(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("health_profile_saved", locale)
	if (locale === "en") return en_health_profile_saved(inputs)
	if (locale === "es") return es_health_profile_saved(inputs)
	if (locale === "de") return de_health_profile_saved(inputs)
	if (locale === "nl") return nl_health_profile_saved(inputs)
	if (locale === "fr") return fr_health_profile_saved(inputs)
	if (locale === "it") return it_health_profile_saved(inputs)
	if (locale === "pt-BR") return pt_br2_health_profile_saved(inputs)
	if (locale === "pt") return pt_health_profile_saved(inputs)
	if (locale === "ja") return ja_health_profile_saved(inputs)
	return zh_health_profile_saved(inputs)
};